export enum ReportsActionTypes {
    API_RESPONSE_SUCCESS = '@@report/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@report/API_RESPONSE_ERROR',
    GET_REPORT_DATA = '@@report/GET_DATA',
    GET_SALES_PIPELINE = '@@report/GET_SALES_PIPELINE',
    UPDATE_SALES_PIPELINE = '@@report/UPDATE_SALES_PIPELINE',

}
